import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
	routes: [
		{path: '/',redirect:'index'},
		{path: '/index',component:()=>import("./pages/index.vue"),name:"首页"},
		{path: '/sign',component:()=>import("./pages/sign.vue"),name:"签到页"},
		
	]
})

